import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoratnagirircab() {



    const cardData = {





keyword: "Mumbai to Ratnagiri Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Mumbai to Ratnagiri Cab Service for family vacations, Konkan tours, business travel, pilgrimage journeys, weekend getaways, and long-distance road trips. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a smooth and relaxing journey from Mumbai to Ratnagiri. With experienced drivers, clean and well-maintained vehicles, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, we ensure a safe and hassle-free travel experience. Whether you are planning a beach holiday, temple visit, heritage tour, or exploring the beautiful Konkan coastline, Shreesha Tours & Travels provides dependable Mumbai to Ratnagiri cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Ganpatipule Temple Ratnagiri",
    description: "Ganpatipule is one of Maharashtra's famous pilgrimage and beach destinations, known for the Swayambhu Ganpati Temple, peaceful beaches, and beautiful Konkan coastline views."
  },
  {
    title: "Ratnadurg Fort Ratnagiri",
    description: "Ratnadurg Fort is a historic sea fort offering stunning Arabian Sea views, ancient architecture, and scenic surroundings. It is a popular attraction for history lovers and photographers."
  },
  {
    title: "Thiba Palace Ratnagiri",
    description: "Thiba Palace is a historic royal residence known for its unique architecture, heritage value, and peaceful surroundings. It is an important attraction while exploring Ratnagiri city."
  },
  {
    title: "Aare Ware Beach Ratnagiri",
    description: "Aare Ware Beach is a beautiful and less crowded coastal destination famous for scenic views, clean surroundings, and peaceful beach experiences."
  },
  {
    title: "Pawas Ratnagiri",
    description: "Pawas is a spiritual destination near Ratnagiri known for the ashram of Swami Swaroopanand and a peaceful atmosphere. It attracts devotees throughout the year."
  },
  {
    title: "Jaigad Fort Ratnagiri",
    description: "Jaigad Fort is a historic coastal fort located near the Shastri River entrance, offering beautiful sea views and insights into Konkan's maritime history."
  },
  {
    title: "Velas Beach",
    description: "Velas Beach is famous for the Olive Ridley Turtle Festival, eco-tourism, and peaceful coastal beauty. It is a perfect destination for nature lovers and families."
  },
  {
    title: "Tarkarli Beach",
    description: "Tarkarli is a popular Konkan beach destination known for clear waters, scuba diving, snorkeling, Sindhudurg Fort, and relaxing seaside vacations."
  },
  {
    title: "Dapoli",
    description: "Dapoli is a scenic coastal town near Ratnagiri known for beaches, temples, forts, and beautiful natural surroundings. It is a popular weekend destination in Konkan."
  },
  {
    title: "Guhagar Beach",
    description: "Guhagar Beach is known for its peaceful shoreline, coconut plantations, clean environment, and relaxing coastal atmosphere. It is ideal for family holidays and nature trips."
  }
],




"services": [
  {
    "name": "Mumbai to Ratnagiri Cab",
    "description": "Book Mumbai to Ratnagiri Cab for safe, comfortable, and reliable Konkan travel with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth journey from Mumbai to Ratnagiri with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family trips, business travel, beach holidays, and sightseeing."
  },
  {
    "name": "Mumbai to Ratnagiri Taxi",
    "description": "Choose Mumbai to Ratnagiri Taxi for convenient and affordable long-distance travel with experienced drivers and comfortable vehicles. Get doorstep pickup, clean AC cars, transparent pricing, and reliable taxi services for personal, family, and tourist journeys."
  },
  {
    "name": "Mumbai to Ratnagiri Cab Service",
    "description": "Book Mumbai to Ratnagiri Cab Service for dependable outstation transportation with trained chauffeurs and premium vehicles. Our cab services provide comfortable travel solutions for Konkan tours, family vacations, business trips, and private journeys."
  },
  {
    "name": "Mumbai to Ratnagiri Taxi Service",
    "description": "Hire Mumbai to Ratnagiri Taxi Service for smooth highway travel with professional drivers and well-maintained cars. Enjoy flexible booking options, comfortable seating, affordable fares, and reliable taxi facilities for your Ratnagiri journey."
  },
  {
    "name": "Mumbai to Ratnagiri Cab Booking",
    "description": "Complete Mumbai to Ratnagiri Cab Booking with easy reservations, quick confirmation, and multiple vehicle options. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your travel needs and group size."
  },
  {
    "name": "Mumbai to Ratnagiri Car Rental",
    "description": "Choose Mumbai to Ratnagiri Car Rental for chauffeur-driven vehicles designed for comfortable Konkan travel. Enjoy spacious cars, experienced drivers, flexible schedules, and affordable rental packages for family trips and sightseeing tours."
  },
  {
    "name": "Mumbai to Ratnagiri One Way Cab",
    "description": "Book Mumbai to Ratnagiri One Way Cab for convenient drop taxi service without return fare charges. Travel comfortably with skilled drivers, clean vehicles, and flexible pickup locations from Mumbai."
  },
  {
    "name": "Mumbai to Ratnagiri Round Trip Taxi",
    "description": "Reserve Mumbai to Ratnagiri Round Trip Taxi for complete return travel with flexible timings and comfortable vehicles. Ideal for Konkan holidays, family tours, sightseeing trips, and extended stays in Ratnagiri."
  },
  {
    "name": "Mumbai to Ratnagiri Outstation Cab",
    "description": "Choose Mumbai to Ratnagiri Outstation Cab for safe and reliable interstate travel with premium vehicles and experienced chauffeurs. Perfect for long-distance journeys, family trips, corporate travel, and Konkan exploration."
  },
  {
    "name": "Mumbai to Ratnagiri Tourist Cab",
    "description": "Book Mumbai to Ratnagiri Tourist Cab for comfortable sightseeing and holiday travel. Explore Ratnagiri beaches, forts, temples, and Konkan attractions with professional drivers and flexible tour cab options."
  },
  {
    "name": "Mumbai Airport to Ratnagiri Cab",
    "description": "Book Mumbai Airport to Ratnagiri Cab for smooth airport pickup and direct travel services. Enjoy timely transfers, luggage-friendly vehicles, professional chauffeurs, and comfortable transportation from Mumbai Airport to Ratnagiri."
  },
  {
    "name": "Mumbai to Ratnagiri Innova Cab",
    "description": "Choose Mumbai to Ratnagiri Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Perfect for families and groups planning a relaxing Konkan journey."
  },
  {
    "name": "Mumbai to Ratnagiri Ertiga Cab",
    "description": "Reserve Mumbai to Ratnagiri Ertiga Cab for affordable group travel with comfortable interiors and reliable performance. Suitable for families and small groups looking for economical outstation cab service."
  },
  {
    "name": "Mumbai Konkan Tour Cab",
    "description": "Book Mumbai Konkan Tour Cab for comfortable road trips across beautiful Konkan destinations. Enjoy customized travel plans, professional chauffeurs, and premium vehicles for beaches, temples, forts, and sightseeing locations."
  },
  {
    "name": "Best Mumbai Ratnagiri Cab Service",
    "description": "Choose the Best Mumbai Ratnagiri Cab Service for safe, comfortable, and reliable Konkan travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and affordable cab packages for family holidays, tourist trips, and long-distance journeys from Mumbai to Ratnagiri."
  }
],
"tableData": [
  ["Mumbai to Ratnagiri Cab", "Mumbai to Ratnagiri Taxi"],
  ["Mumbai to Ratnagiri Cab Service", "Mumbai to Ratnagiri Taxi Service"],
  ["Mumbai to Ratnagiri Cab Booking", "Mumbai to Ratnagiri Car Rental"],
  ["Mumbai to Ratnagiri One Way Cab", "Mumbai to Ratnagiri Round Trip Taxi"],
  ["Mumbai to Ratnagiri Outstation Cab", "Mumbai to Ratnagiri Tourist Cab"],
  ["Mumbai Airport to Ratnagiri Cab", "Mumbai to Ratnagiri Innova Cab"],
  ["Mumbai to Ratnagiri Ertiga Cab", "Mumbai Konkan Tour Cab"],
  ["Best Mumbai Ratnagiri Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ratnagiri Cab Service",
    WhyChoosedescription: "Shreesha Travels offers reliable Mumbai to Ratnagiri cab services for families, tourists, business travellers, and coastal explorers. Enjoy a smooth journey to the Konkan region with comfortable vehicles, experienced drivers, and flexible travel options."
  },
  {
    WhyChooseheading: "Explore Ratnagiri & Konkan with Ease",
    WhyChoosedescription: "Travel from Mumbai to Ratnagiri and explore beautiful destinations like Ganpatipule, Ratnadurg Fort, Thibaw Palace, beaches, temples, and scenic Konkan locations with customized cab plans."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles for Every Trip",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other comfortable vehicles based on your travel group."
  },
  {
    WhyChooseheading: "Perfect for Family Vacations & Konkan Tours",
    WhyChoosedescription: "Our Mumbai to Ratnagiri taxis are ideal for family holidays, weekend getaways, beach trips, temple visits, sightseeing tours, and customized Konkan travel packages."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Booking",
    WhyChoosedescription: "Select a one-way cab for direct travel to Ratnagiri or choose a round-trip package with flexible return schedules, sightseeing stops, and personalized itineraries."
  },
  {
    WhyChooseheading: "Experienced Drivers for Konkan Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Maharashtra highways and Konkan roads, ensuring safe driving, comfortable travel, and timely service throughout the journey."
  },
  {
    WhyChooseheading: "Clean & Reliable Cars for Long Routes",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before departure to provide a pleasant and hassle-free Mumbai to Ratnagiri travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Ratnagiri Cab with Shreesha Travels",
    WhyChoosedescription: "Get dependable cab assistance, transparent pricing, comfortable vehicles, and professional chauffeur services for your Mumbai to Ratnagiri journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Ratnagiri cab for a family trip?",
    answer: "Yes, we provide comfortable Mumbai to Ratnagiri cabs for family vacations, sightseeing tours, and Konkan holidays."
  },
  {
    question: "Is Mumbai to Ratnagiri one-way cab service available?",
    answer: "Yes, one-way cab bookings are available for passengers who need direct travel from Mumbai to Ratnagiri."
  },
  {
    question: "Which vehicles are available for Mumbai to Ratnagiri travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "What places can I visit near Ratnagiri?",
    answer: "Popular places include Ganpatipule, Ratnadurg Fort, beaches, temples, historical attractions, and scenic Konkan locations."
  },
  {
    question: "Is Ratnagiri cab service suitable for senior citizens?",
    answer: "Yes, comfortable vehicles and experienced drivers make the journey convenient for senior citizens and families."
  },
  {
    question: "Can I customize my Mumbai to Ratnagiri travel route?",
    answer: "Yes, you can add sightseeing stops, nearby destinations, and customized travel plans according to your requirements."
  },
  {
    question: "Do you provide round-trip Mumbai to Ratnagiri taxis?",
    answer: "Yes, round-trip cab services are available with flexible return schedules and travel plans."
  },
  {
    question: "How is the Mumbai to Ratnagiri cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip duration, route, waiting time, and selected package."
  },
  {
    question: "Can I book a cab for Konkan sightseeing tours?",
    answer: "Yes, customized Konkan sightseeing packages covering Ratnagiri and nearby destinations are available."
  },
  {
    question: "How can I book Mumbai to Ratnagiri Cab with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger count, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Sawant",
    feedback: "The Mumbai to Ratnagiri journey was very comfortable. The driver knew the route well, the car was clean, and our Konkan trip was managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "We had a wonderful family trip with Shreesha Travels. The vehicle was spacious, the service was professional, and the entire journey was enjoyable.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ratnagiri Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-ratnagiri-cab.webp",
  "description":
    "Book Mumbai to Ratnagiri Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Konkan trips, family vacations, sightseeing tours, business travel, and long-distance journeys from Mumbai to Ratnagiri with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-ratnagiri-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Mumbai to Ratnagiri Cab | Konkan Tour Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Ratnagiri Cab with Shreesha Travels for reliable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Konkan travel, family trips, sightseeing, and one-way or round-trip journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Ratnagiri Cab, Mumbai to Ratnagiri Taxi, Mumbai to Ratnagiri Cab Service, Mumbai to Ratnagiri Taxi Service, Mumbai to Ratnagiri Cab Booking, Mumbai to Ratnagiri Car Rental, Mumbai to Ratnagiri One Way Cab, Mumbai to Ratnagiri Round Trip Taxi, Mumbai Ratnagiri Outstation Cab, Mumbai Konkan Tour Cab, Ratnagiri Taxi Service from Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoratnagirircab;